const ProductTypes = {
    ADDON: "add-on",
    PRODUCT: "product",
};

export default ProductTypes;
